import { render, staticRenderFns } from "./PurchaseItem.view.vue?vue&type=template&id=0c6d887e&"
import script from "./PurchaseItem.view.vue?vue&type=script&lang=js&"
export * from "./PurchaseItem.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c6d887e')) {
      api.createRecord('0c6d887e', component.options)
    } else {
      api.reload('0c6d887e', component.options)
    }
    module.hot.accept("./PurchaseItem.view.vue?vue&type=template&id=0c6d887e&", function () {
      api.rerender('0c6d887e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/list/partials/PurchaseItem.view.vue"
export default component.exports